import { render, staticRenderFns } from "./manageRigs.vue?vue&type=template&id=52f5702a"
import script from "./manageRigs.vue?vue&type=script&lang=ts"
export * from "./manageRigs.vue?vue&type=script&lang=ts"
import style0 from "./manageRigs.vue?vue&type=style&index=0&id=52f5702a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports